import { UpdateAccountGroupsShareApi } from "@/features/accounts/account-group/services/update-account-groups-share-api";
import { UpdateAccountGroupsShareRequestModel } from "@/features/accounts/account-group/services/update-account-groups-share-model";

/// 口座グループ共有メンバー更新
export class UpdateAccountGroupsShareService {
  private updateAccountGroupsShareApi = new UpdateAccountGroupsShareApi();

  /**
   * 口座グループ共有メンバー更新
   */
  public async updateAccountGroupsShare(param: UpdateAccountGroupsShareRequestModel) {
    return await this.updateAccountGroupsShareApi.updateAccountGroupsShare(param);
  }
}

